import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

export default function WhatsAppChat() {
    const phoneNumber = '919311036909';
    const whatsappUrl = `https://wa.me/${phoneNumber}`;

    const handleWhatsAppClick = () => {
        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="whatsapp-chat">
            <button
                onClick={handleWhatsAppClick}
                className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-green-300"
                aria-label="Chat with us on WhatsApp"
                title="Chat with us on WhatsApp"
            >
                <FaWhatsapp className="w-7 h-7" />
            </button>

            {/* Pulse Animation */}
            <div className="absolute inset-0 w-14 h-14 bg-green-500 rounded-full animate-ping opacity-20 pointer-events-none"></div>
        </div>
    );
}